import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    // When enabled, an option must be clicked twice: the first click only marks
    // it as pending (yellow), the second click on the same option confirms it.
    doubleClickConfirm: true,
}

export const settingsSlice = createSlice({
    name: 'settings',
    initialState,
    reducers: {
        toggleDoubleClickConfirm:(state)=>{
            state.doubleClickConfirm=!state.doubleClickConfirm
        },
    },
})

export const {toggleDoubleClickConfirm} =settingsSlice.actions
export default settingsSlice.reducer
